import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-heading text-background-50 mb-4">草榴回家的路</h3>
              <p className="text-sm text-background-400 leading-relaxed">
                草榴回家的路官方导航站，提供最新地址入口、访问教程与常见问题解答，助力每一位用户找到回家的路。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-100 mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/category/zuixin-dizhi" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    最新地址
                  </Link>
                </li>
                <li>
                  <Link to="/category/fangwen-jiaocheng" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    访问教程
                  </Link>
                </li>
                <li>
                  <Link to="/category/changjian-wenti" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    常见问题
                  </Link>
                </li>
                <li>
                  <Link to="/category/shiyong-jiqiao" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    使用技巧
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-100 mb-4">关于我们</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    用户口碑
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    联系我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-100 mb-4">免责声明</h4>
              <p className="text-sm text-background-400 leading-relaxed">
                本站仅提供导航与信息聚合服务，不存储任何社区内容。所有地址信息仅供学习交流使用，请遵守当地法律法规。
              </p>
            </div>
          </div>

          <div className="border-t border-background-700 mt-8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} 草榴回家的路 - 官方导航站. 版权所有.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-400 hover:text-background-100 transition-colors" rel="nofollow">
                <i className="ri-shield-check-line text-lg" />
              </a>
              <a href="#" className="text-background-400 hover:text-background-100 transition-colors" rel="nofollow">
                <i className="ri-github-line text-lg" />
              </a>
              <a href="#" className="text-background-400 hover:text-background-100 transition-colors" rel="nofollow">
                <i className="ri-mail-line text-lg" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}